module.exports = __webpack_public_path__ + "img/office.59a85c07.svg";